<template>
    <div class="business">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col class="middle"
                    :span="20">
                <el-col class="main"
                        :span="8"
                        v-for="(item,index) in contentlist"
                        :key="index">
                    <div class="main-inner">
                        <div class="inner"> <img class="icoImg"
                                 :src="item.image" />
                            <p class="big">{{item.title}}</p>
                            <p class="Single ">{{item.description}}</p>
                        </div>
                    </div>
                </el-col>
                <el-col class="immediately">
                    <el-button @click="toLink('在线下单')"> 立即下单 </el-button>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { menuqueryaddressid } from "@/api/menu";
export default {
    name: "business",
    data() {
        return {
            routerUrl: ""
        };
    },
    computed: {
        ...mapGetters(["activeIndex", "contentlist"])
    },
    created() {
        this.aueryfindbytype();
        // debugger
        // if (this.$route.query.id) {
        //     this.$store.dispatch("ContentDescList", this.$route.query.id);
        // }
    },

    methods: {
        aueryfindbytype() {
            menuqueryaddressid({ name: "登录", sign: "1" }).then(res => {
                if (res.status == 2000) {
                    this.routerUrl = res.data.routAddress;
                }
            });
        },
        toLink(name, sign) {
            let MenuQueryDto = {};
            if (sign) {
                MenuQueryDto = { name: name, sign: sign };
            } else {
                MenuQueryDto = { name: name };
            }
            // menuqueryaddressid(MenuQueryDto).then(res => {
            //     // this.$store.dispatch("UpdateActive", res.data);
            //     this.$router.push({
            //         path: res.data.demoFlag,
            //         query: {
            //             id: res.data.id
            //         }
            //     });
            // });
            this.$router.push({
                path:'/demoModel?id=FE84E2AC-9656-D301-7308-74CA31EA6929'
            })
        }
    }
};
</script>

<style scoped lang="scss">
.business {
    padding-bottom: 79px;
    background-color: #f5f6f7;
    .middle {
        .center {
            .head {
                margin-top: 60px;
                font-size: 20px;
                text-align: center;
            }
            .text {
                text-align: center;
                margin-top: 20px;
                font-size: 14px;
            }
        }
        .main {
            margin-top: 50px !important;
            padding: 0 12px;
            height: 271px;

            // border: 1px solid #ccc;
            .main-inner {
                height: 271px;
                background-color: #fff;
                border: 1px solid #ddd;
            }
            .inner {
                // padding-bottom: 10px;
                // position: relative;
                // top: 50%;
                // transform: translateY(-50%);
            }
            img {
                margin-top: 47px;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
            }
            p {
                text-align: center;
                margin-top: 20px;
                line-height: 26px;
            }
            .big {
                font-weight: 400;
                font-size: 20px;
                margin-top: 20px;
            }
            .Single {
                margin-top: 20px;
                padding: 0 15px;
                color: #666;
                font-size: 14px;
            }
            .Promise {
                margin-top: 5px;
                // margin-bottom: 20px;
            }
        }
        .main:hover {
            transition: transform 0.7s;
            transform: translateY(-10px);
        }
    }
}
</style>
